module.exports = __webpack_public_path__ + "media/images/redesign-images/collabs/influencers/influencer-hamptons-85393229785645e0256db19d8aec197f.jpg";